import { F } from "@angular/cdk/keycodes";
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  OnDestroy,
  SimpleChanges,
  ViewChild,
  Inject
} from "@angular/core";
import {
  MatTable,
  MatTableDataSource,
} from "@angular/material/table";
import {MatButtonToggleGroup} from "@angular/material/button-toggle";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Subject, Subscription } from "rxjs";
import { debounceTime, take, takeUntil } from "rxjs/operators";
import { TabChangeService } from "src/app/services/tab-change.service";
import { ModalTabVisibilityService } from '../../services/modal-tab-visibility.service';
import { DiagnosisComponent } from "src/app/diagnosis/diagnosis.component";
import { CommonService } from "src/app/services/common.service";
import beautify from "xml-beautifier";
import { DataValidationComponent } from '../../Model/data-validation/data-validation.component';
import { data } from 'highcharts';
import { FileViewExplorerComponent } from 'src/app/file-view-explorer/file-view-explorer.component';
import { ConsolidateviewfileComponent } from 'src/app/consolidateviewfile/consolidateviewfile.component';
 import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/confirm-dialog/confirm-dialog.component';
 import { MatDialog } from '@angular/material/dialog';
 // import { Overlay } from '@angular/cdk/overlay';
  import { Hl7viewerComponent } from 'src/app/hl7viewer/hl7viewer.component';

declare const copyToClipboard: any;
declare var $;

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}
// const DEFINITIONS: ColumnDefintion[] = [
//   // width => width of the column
//   // left => width of the previous column
//   {label: 'Handler Status', },
//   {label: 'Rule Status', },
//   {label: 'CaseType'},
//   {label: 'Service'},
//   {label: 'LabId'},
//   {label: 'LabOrgId'},
//   {label: 'OrdFacilityId'},
//   {label: 'OrdFacOrgId'},
//   {label: 'OrdPhysician'},
//   {label: 'RefPhysician'},
//   {label: 'PathologistId'},
//   {label: 'PathAccountId'},
//   {label: 'CaseStatus'},
//   {label: 'ExOrdFacilityId'},
//   {label: 'ExServices'},
//   {label: 'ExCaseTypes'},

//   {label: 'EffectiveDate'},
//   {label: 'ExpiryDate'},
//   {label: 'TestMode'},
// ]

export interface ColumnDefintion {
  label: string;
  sticky?: boolean;
  style?: any;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: "Hydrogen", weight: 1.0079, symbol: "H" },
  { position: 2, name: "Helium", weight: 4.0026, symbol: "He" },
  { position: 3, name: "Lithium", weight: 6.941, symbol: "Li" },
  { position: 4, name: "Beryllium", weight: 9.0122, symbol: "Be" },
  { position: 5, name: "Boron", weight: 10.811, symbol: "B" },
  { position: 6, name: "Carbon", weight: 12.0107, symbol: "C" },
  { position: 7, name: "Nitrogen", weight: 14.0067, symbol: "N" },
  { position: 8, name: "Oxygen", weight: 15.9994, symbol: "O" },
  { position: 9, name: "Fluorine", weight: 18.9984, symbol: "F" },
  { position: 10, name: "Neon", weight: 20.1797, symbol: "Ne" },
];
@Component({
  selector: "app-casemessage",
  templateUrl: "./casemessage.component.html",
  styleUrls: ["./casemessage.component.scss"],
})
export class CasemessageComponent implements OnInit, OnDestroy {
  filterHandlerSearch: string = "";
  //@Input() requisitionNumber: any = "";
  ftpfiledata: any = {};
  isFolderView: boolean = false;
  
  // Modal tab management
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'case 360 prime';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];
  eventLogListBackup: any;
  MessagesList: any;
  selectedHandler: any = "";
  selectedInput: any;
  selectedOutput: any;
  selectedMessage: any;
  message_iot_data: Object;
  pagerolepermisions: any;
  formatType: string = "xml";
  MessageTraceData: any;
  messagereprocessdata: any[];
  IneventLogListBackup: any;
  selectedDirection: any;
  displaymessageid: any;
  selectedTabIndex = 0;
  searchTextValue: any = "";
  AfterChangeInlogsbackup: any[];
  AfterChangelogsbackup: any[];
  mediatypedisplay: boolean;
  selectedfilecontent: ArrayBufferLike;
  viewHL7Files: any;
  viewfileHandlerName: any;
  viewfileRoutguid: any;
  selectedMessageType: any;
  selectedStageData: any;
  msgObjforiot: any;
  casesruleinfo: any[] = [];
  varuleinfo: any[] = [];
  fileidarray: any[] = [];
  backupfileArray: any[]=[];
  downloadbuttonenable: boolean = true;
  fixedcolomun = [
    "Indentifier",
    "DisplayHandlerStatus",
    "DisplayRuleStatus",
    "EffectiveDate",
    "ExpiryDate",
    "TestMode",
  ];
  ngZone: any;
  @ViewChild("MatTable", { static: false }) Table: MatTable<any>;

  // @ViewChild('matTable', { static: false }) set table(matTable: MatTable<any>) {
  //   if (matTable) {
  //     this.ngZone.onMicrotaskEmpty
  //       .pipe(take(3))
  //       .subscribe(() => matTable.updateStickyColumnStyles())
  //   }
  // }
  isTables: boolean = true;

  differenceColumns = [
    // { name: "DisplayHandlerStatus", label: "Handler Status" },
    // { name: "DisplayRuleStatus", label: "Rule Status" },
    // { name: "CaseType", label: "Case Type" },
    // { name: "Service", label: "Service" },
    // { name: "CaseId", label: "Case Id" },
    // { name: "LabAccountName", label: "Lab Name" },
    // { name: "LabOrgName", label: "Lab Org Name" },
  ];
  displayedColumns = this.differenceColumns;
  AllColumns = [
    { name: "Indentifier", label: "" },
    { name: "DisplayHandlerStatus", label: "Handler Status" },
    { name: "DisplayRuleStatus", label: "Rule Status" },
    { name: "CaseType", label: "Case Type" },
    { name: "Service", label: "Service" },
    { name: "CaseId", label: "Case Id" },
    { name: "LabAccountName", label: "Lab Name" },
    { name: "LabOrgName", label: "Lab Org Name" },
    { name: "OFAccountName", label: "Facility Name" },
    { name: "OrdFacOrgName", label: "Facility Org Name" },
    { name: "PhysicianUserName", label: "Ordering Physician" },
    { name: "RefPhysician", label: "Referring Physician" },
    { name: "PathologistUserName", label: "Pathologist" },
    { name: "PathOrgName", label: "Pathologist Org Name" },
    { name: "PathAccountName", label: "Pathologist Account Name" },
    { name: "CaseStatus", label: "Case Status" },
    { name: "ExOrdFacilityId", label: "Excluded Facilities" },
    { name: "ExServices", label: "Excluded Services" },
    { name: "ExCaseTypes", label: "Excluded CaseTypes" },
    { name: "EffectiveDate", label: "Effective Date" },
    { name: "ExpiryDate", label: "Expiry Date" },
    { name: "TestMode", label: "Test Mode " },
  ];
  // dataSource = ELEMENT_DATA;
  // COL_DEFINITIONS = DEFINITIONS;
  displayedColumnstab = this.displayedColumns.map((def) => def.name);
  // dataSource = ELEMENT_DATA;
  // displayedColumns: string[] = [
  //   'col1',
  //   'col2',
  //   'col3',
  //   'col4',
  //   'col5',
  //   'col6',
  //   'col7',
  //   'col8',
  //   'col9',
  //   'col10',
  //   'col11',
  //   'col12',
  //   'col13',
  //   'col14',
  //   'col15',
  //   'col16',
  //   'col17',
  //   'col18',
  // ];
  dataSource = new MatTableDataSource<TableData>(TABLE_DATA);
  Alldata: any[];
islabadmin:boolean=false;
  // tables = [0];
  defaultFormatType:string='text/plain'
  constructor(
    private service: CommonService,
    private modalService: NgbModal,
    private ngxUiLoaderService: NgxUiLoaderService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    // private overlay: Overlay,
    @Inject('caseData') public requisitionNumber: any,
    private tabChangeService: TabChangeService,
    private modalTabVisibility: ModalTabVisibilityService,
    private cdr: ChangeDetectorRef
  ) {
    // this.displayedColumns.length = 24;
    // this.displayedColumns.fill('filler');
    // // The first two columns should be position and name; the last two columns: weight, symbol
    // this.displayedColumns[0] = 'position';
    // this.displayedColumns[1] = 'name';
    // this.displayedColumns[22] = 'weight';
    // this.displayedColumns[23] = 'symbol';
    const selectedRole = sessionStorage.getItem("SelectedUserRole");
    if (selectedRole === 'LabAdminCase360' || selectedRole?.toLowerCase() === 'admin3') {
      this.islabadmin = true;
    }
  }

  // isSticky(buttonToggleGroup: MatButtonToggleGroup, id: string) {
  //
  //   if(buttonToggleGroup !== undefined) {
  //     return (buttonToggleGroup.value || []).indexOf(id) !== -1;
  //   }else{return true}

  // }

  isSticky(column: string): boolean {
    let wdir = this.fixedcolomun.filter((va) => va == column);
    if (wdir.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  isStickyEnd(column: string): boolean {
    let wdir = this.fixedcolomun.filter((va) => va == column);
    if (wdir.length > 0) {
      return true;
    } else {
      return false;
    }

  }
  EventList = [];
  InEventList = [];
  IneventLogList = [];
  eventLogList = [];
  InboundeventLogList = [
    {
      eventName: "",
      logName: "test_fileid_SPC_TEST_DALLAS.LIS.result.Outbound",
      messageid: "a68f004c-e04f-4905-8f09-6fdbc2ebc155",
      messageStatus: "success",
      messageDate: "01/27/2023 10:34:21",
      messageMode: "LIVE",
      isActive: true,
    },
  ];
  iconsList = [];
  editorOptions = {
    theme: 'vs', language: this.formatType,readOnly:true, wordWrap: 'on',scrollBeyondLastLine: false
};
  messageiotreprocess: boolean;
  backupinputdata: any;
  folderviewSubscribe: Subscription;

  ngOnInit() {
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.modalTabVisibility.hideForeignOwnedModals('data-case360-modal');
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });
    this.service.timezoneChanged$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.cdr.markForCheck();
    });
    
    this.EventList = [];
    this.InEventList = [];
    this.IneventLogList = [];
    this.eventLogList = [];
    if (this.requisitionNumber.ReqNumber !== undefined) {
      this.isFolderView = false;
      this.selectedHandler = "";
      this.selectedTabIndex = 0;
      setTimeout(() => {
        this.onTabChanged(0);
      });
      // this.InBoundList();
      // this.OutBoundList()
    } else {
      this.selectedTabIndex = 0;
    }
    this.folderviewSubscribe = this.service.viewfileview.subscribe((data) => {
      if (data) {
        this.isFolderView = false;
      } else {
        this.isFolderView = true;
      }
    });
  }
  ngAfterViewInit() {
    this.selectedTabIndex = 0;
  }
  // ngAfterViewInit(): void {

  // }
  ngAfterViewChecked() {
    if (this.Table) {
      this.Table.updateStickyColumnStyles();
    }
    // this.selectedTabIndex = 0;
  }
  InBoundList() {
    this.requisitionNumber = {
      ...this.requisitionNumber,
      Direction: "Inbound",
    };
    this.ngxUiLoaderService.start();
    this.service.getInterfaceDetails360(this.requisitionNumber).subscribe(
      (data) => {
        this.ngxUiLoaderService.stop();
        if (data.MessageTypes !== null) {
          this.InEventList = [];
          data.MessageTypes.forEach((element, index) => {
            let obj = { name: element, isactive: index == 0 ? true : false };
            this.InEventList.push(obj);
          });
          this.IneventLogListBackup = JSON.parse(
            JSON.stringify(data.Pipelines)
          );
          this.IneventLogList = JSON.parse(JSON.stringify(data.Pipelines));
          this.InselectedEvent(0);
        }
      },
      (error) => {
        this.ngxUiLoaderService.stop();
        //console.error();
      }
    );
  }
  OutBoundList() {
    this.requisitionNumber = {
      ...this.requisitionNumber,
      Direction: "Outbound",
    };
    this.ngxUiLoaderService.start();
    this.service.getInterfaceDetails360(this.requisitionNumber).subscribe(
      (data) => {
        this.ngxUiLoaderService.stop();

        if (data.MessageTypes !== null) {
          this.EventList = [];
          data.MessageTypes.forEach((element, index) => {
            let obj = { name: element, isactive: index == 0 ? true : false };
            this.EventList.push(obj);
          });
          this.eventLogListBackup = JSON.parse(JSON.stringify(data.Pipelines));
          this.eventLogList = data.Pipelines;
          this.selectedEvent(0);
        }
      },
      (error) => {
        // console.error(error);
        this.ngxUiLoaderService.stop();
      }
    );
  }

  HL7Viewer(message: string) {
  if (message === "") {
    this.toastr.error("The given input is empty", "", {
      timeOut: 4000,
      positionClass: "toast-bottom-right",
    });
    return;
  }

  if (!message.startsWith('MSH|^')) {
    this.toastr.error("The given input is not in HL7 format", "", {
      timeOut: 4000,
      positionClass: "toast-bottom-right",
    });
    return;
  }
  const formattedMessage = this.formatHL7Data(message);
  const modalRef = this.modalService.open(Hl7viewerComponent, {
    windowClass: "myCustomModalClasscase360hl7",
    backdrop: 'static',
    keyboard: false
  });
  modalRef.componentInstance.inputDataInModalComponent = formattedMessage;
  this.currentModalRefs.push(modalRef);
  
  modalRef.result.then(() => {
    this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
  }, (reason) => {
    this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
  });
  
  // Add data attribute to identify the modal and backdrop
  this.modalTabVisibility.tagOwned('data-case360-modal', 'myCustomModalClasscase360hl7');
  
  this.modalWasOpen = true;
}

private formatHL7Data(data: string): string {
  if (data === "") return "";

  data = data.replace(/\[tempData1\]/g, ""); // remove placeholders
  return data.replace(/\[tempData\]/g, "\n"); // add line breaks
}

  getMatValue(column, i) {
    if (this.dataSource.data.length - 1 !== i) {
      switch (column) {
        case "LabAccountName":
          return this.dataSource.data[i]["LabId"];
          break;
        case "LabOrgName":
          return this.dataSource.data[i]["LabOrgId"];
          break;
        case "OFAccountName":
          return this.dataSource.data[i]["OrdFacilityId"];
          break;

        default:
          break;
      }
    } else {
      return this.dataSource.data[i][column];
    }
  }

  ChangesTable(event: any) {
    if (this.isTables) {
      this.displayedColumns = this.differenceColumns;
      this.dataSource.data = this.Alldata;
    } else {
      this.displayedColumns = this.AllColumns;
      this.dataSource.data = this.Alldata;
    }
    this.displayedColumnstab = this.displayedColumns.map((def) => def.name);
  }

  openDiagnostics() {
    this.ngxUiLoaderService.start();
    const modalRef = this.modalService.open(DiagnosisComponent, {
      windowClass: "myCustomModalClassFTPcase360",
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.routeGuid = this.selectedHandler;
    modalRef.componentInstance.DisplaynameRoute =
      this.selectedHandler.RouteName;
    this.currentModalRefs.push(modalRef);
    
    modalRef.result.then((result) => {
      this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
    }, (reason) => {
      this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
    });
    
    // Add data attribute to identify the modal and backdrop
    this.modalTabVisibility.tagOwned('data-case360-modal', 'myCustomModalClassFTPcase360');
    
    this.modalWasOpen = true;
  }
  openFolder(item) {
    this.isFolderView = true;
    this.ftpfiledata = {
      routeId: this.selectedHandler.RouteGuid,
      sourceagent: this.selectedHandler.SourceAgentId,
      name: this.selectedHandler.RouteName,
      uniqid: this.selectedHandler.RouteUniqueId,
      selectflag: false,
      case360: true,
    };
  }
 
  rolepermission() {
    const menuid = JSON.parse(sessionStorage.getItem("rolewithmenus"))
      .find((x) => x.RoleName == sessionStorage.getItem("SelectedUserRole"))
      .menuslist.find((y) => y.MenuDisplayName == "MESSAGES").MenuId;
    const actionitems = JSON.parse(sessionStorage.getItem("rolewithmenus"))
      .find((x) => x.RoleName == sessionStorage.getItem("SelectedUserRole"))
      .menuslist.filter((y) => y.ParentMenuId == menuid);
    actionitems.forEach((element) => {
      this.pagerolepermisions[element.MenuName] = true;
    });
  }
  closemessageiotpopup(c) {
    // this.editorOptions1.readOnly = true;
    // this.messageiotreprocess = false;
    // this.viewHL7Files = "";
    c("close modal");
  }
  ViewFileData(item: any, modalmessageiot) {
    this.ngxUiLoaderService.start();
    let obj = {
      LogId: this.selectedHandler.LastMessage.TransactionId,
      Deploymentkey: this.requisitionNumber.DeploymentKey,
    };
    this.service.viewFilesCase_hanlder(obj).subscribe(
      (data) => {
        if (data.status == "failure") {
          this.ngxUiLoaderService.stop();
          this.toastr.warning("File not available", "", {
            positionClass: "toast-bottom-right",
            timeOut: 4000,
          });
        } else {
          let modalsize = "";
          this.ngxUiLoaderService.stop();
          data.responsebody = JSON.parse(data.responsebody);
          if (
            data.responsebody !== null &&
            data.responsebody.filecontent !== null
          ) {
            if (data.responsebody.fileformat == "pdf") {
              modalsize = "viewpdffile";
              this.mediatypedisplay = false;
              this.selectedfilecontent = this._base64ToArrayBuffer(
                data.responsebody.filecontent
              );
            } else {
              this.mediatypedisplay = true;
              modalsize = "viewfiles";
              this.viewHL7Files = data.responsebody.filecontent;
            }
            this.service.auditsave("View", "", "Viewed file in message screen for route :-"+this.selectedHandler.RouteName, "case", this.requisitionNumber['caseguid'], "Case message tab ,deployment key :-"+this.requisitionNumber.DeploymentKey);
            this.viewfileHandlerName = this.selectedHandler.RouteName;
            this.viewfileRoutguid = this.selectedHandler.RouteGuid;
            const modalRef = this.modalService
              .open(modalmessageiot, {
                windowClass: modalsize + "case360",
                backdrop: "static",
                keyboard: false,
              });
            this.currentModalRefs.push(modalRef);
            
            modalRef.result.then((result) => {
              this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
            }, (reason) => {
              this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
            });
            
            // Add data attribute to identify the modal and backdrop
            this.modalTabVisibility.tagOwned('data-case360-modal');
            
            this.modalWasOpen = true;
          } else {
            this.ngxUiLoaderService.stop();
            this.toastr.warning("Data not Found", "Alert", {
              positionClass: "toast-bottom-right",
              timeOut: 4000,
            });
          }
        }
      },
      (error) => {
        this.ngxUiLoaderService.stop();
        this.service.copyableToastError(error.statusText,'Failed');
      }
    );
  }
  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, "");
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  closemoreinfopopup(c) {
    c("close modal");
  }
  closeModal(c) {
    c("close modal");
  }
  selectedEvent(index: number) {
    if (this.EventList.length > 0) {
      this.EventList.map((va) => (va.isactive = false));
      this.EventList[index].isactive = true;
      let name =
        this.EventList[index] !== undefined
          ? this.EventList[index].name.toLowerCase()
          : "";
      this.selectedMessageType =
        this.EventList[index] !== undefined
          ? this.EventList[index].name.toLowerCase()
          : "";
      if (this.eventLogListBackup.length > 0) {
        switch (name) {
          case "all":
            if (this.searchTextValue === "") {
              this.eventLogList = this.eventLogListBackup;
            } else if (this.AfterChangelogsbackup !== undefined) {
              this.eventLogList = this.AfterChangelogsbackup;
            }
            break;
          case "failed":
            if (this.searchTextValue === "") {
              this.eventLogList = this.eventLogListBackup.filter(
                (log) => log.MessageFailedUniqueIds !== ""
              );
            } else if (this.AfterChangelogsbackup !== undefined) {
              this.eventLogList = this.AfterChangelogsbackup.filter(
                (log) => log.MessageFailedUniqueIds !== ""
              );
            }
            break;
          default:
            if (this.searchTextValue === "") {
              this.eventLogList = this.eventLogListBackup.filter(
                (va) =>
                  va.MessageType == this.EventList[index].name.toLowerCase()
              );
            } else if (this.AfterChangelogsbackup !== undefined) {
              this.eventLogList = this.AfterChangelogsbackup.filter(
                (va) =>
                  va.MessageType == this.EventList[index].name.toLowerCase()
              );
            }
            break;
        }
        this.selectedEventCard(0, "out");
      } else {
        this.selectedHandler = "";
        this.MessagesList = [];
      }
    }
  }
  InselectedEvent(index: number) {
    if (this.InEventList.length > 0) {
      this.InEventList.map((va) => (va.isactive = false));
      this.InEventList[index].isactive = true;
      let name =
        this.InEventList[index] !== undefined
          ? this.InEventList[index].name.toLowerCase()
          : "";
      this.selectedMessageType =
        this.InEventList[index] !== undefined
          ? this.InEventList[index].name.toLowerCase()
          : "";
      switch (name) {
        case "all":
          if (this.searchTextValue === "") {
            this.IneventLogList = this.IneventLogListBackup;
          } else if (this.AfterChangeInlogsbackup !== undefined) {
            this.IneventLogList = this.AfterChangeInlogsbackup;
          }
          break;
        case "failed":
          if (this.searchTextValue === "") {
            this.IneventLogList = this.IneventLogListBackup.filter(
              (log) => log.MessageFailedUniqueIds !== ""
            );
          } else if (this.AfterChangeInlogsbackup !== undefined) {
            this.IneventLogList = this.AfterChangeInlogsbackup.filter(
              (log) => log.MessageFailedUniqueIds !== ""
            );
          }
          break;
        default:
          if (this.searchTextValue === "") {
            this.IneventLogList = this.IneventLogListBackup.filter(
              (va) =>
                va.MessageType == this.InEventList[index].name.toLowerCase()
            );
          } else if (this.AfterChangeInlogsbackup !== undefined) {
            this.IneventLogList = this.AfterChangeInlogsbackup.filter(
              (va) =>
                va.MessageType == this.InEventList[index].name.toLowerCase()
            );
          }
          break;
      }
      this.selectedEventCard(0, "in");
    }
  }
  download() {
    this.ngxUiLoaderService.start();
    this.downloadFile(
      this.MessageTraceData,
      this.MessageTraceData[0]["traceid"]
    );
    this.ngxUiLoaderService.stop();
  }
  getmessages(obj) {
    if (obj.MessageUniqueIds != "") {
      this.ngxUiLoaderService.start();
      this.service.getInterfaceDetailsMessages360(obj).subscribe(
        (data) => {
          this.ngxUiLoaderService.stop();
          if (data.length > 0) {
            this.MessagesList = data;
          } else {
            this.MessagesList = [];
          }
        },
        (error) => {
          this.ngxUiLoaderService.stop();
          this.MessagesList = [];
        }
      );
    } else {
      this.MessagesList = [];
    }
  }
  selectedEventCard(index: number, direction) {
    this.selectedDirection = direction;
    this.isFolderView = false;
    this.selectedHandler = "";
    if (direction == "in") {
      if (this.IneventLogList !== undefined && this.IneventLogList.length > 0) {
        this.IneventLogList.map((va) => (va.isActive = false));
        this.IneventLogList[index].isActive = true;
        this.selectedHandler = this.IneventLogList[index];

        let obj = {
          MessageUniqueIds: "",
        };
        if (this.selectedMessageType == "failed") {
          obj.MessageUniqueIds = this.selectedHandler.MessageFailedUniqueIds;
        } else {
          obj.MessageUniqueIds = this.selectedHandler.MessageUniqueIds;
        }
        this.getmessages(obj);
      }
    } else {
      this.isTables = true;
      if (this.eventLogList !== undefined && this.eventLogList.length > 0) {
        this.eventLogList.map((va) => (va.isActive = false));
        this.eventLogList[index].isActive = true;
        this.selectedHandler = this.eventLogList[index];
      }
      if (
        this.eventLogList[index] !== undefined &&
        this.eventLogList[index].Qualified
      ) {
        let obj = {
          MessageUniqueIds: "",
        };
        if (this.selectedMessageType == "failed") {
          obj.MessageUniqueIds = this.selectedHandler.MessageFailedUniqueIds;
        } else {
          obj.MessageUniqueIds = this.selectedHandler.MessageUniqueIds;
        }
        this.getmessages(obj);
      } else {
        if (direction == "out") {
          this.getRules();
        }
      }

    }

  }
  checkvalue(value, index) {
    switch (value) {
      case "DisplayHandlerStatus":
        if (this.dataSource.data[index][value] == "Active") {
          return "text_green _600";
        } else {
          return "text-danger _600";
        }
        break;
      case "DisplayRuleStatus":
        if (this.dataSource.data[index][value] == "Active") {
          return "text_green _600";
        } else {
          return "text-danger _600";
        }
        break;
      case "Indentifier":
        return "_600";
        break;

      default:
        if (
          this.dataSource.data[this.dataSource.data.length - 1][value] !==
          undefined && index !== this.dataSource.data.length - 1) {
          let lastvalue = ''

          if (this.dataSource.data[this.dataSource.data.length - 1][value].includes("(")) {
            let splitedData = this.dataSource.data[this.dataSource.data.length - 1][value].split("(")
            if (splitedData.length) {
              lastvalue = splitedData[1].split(")")[0]
            }
          }
          else {
            lastvalue = this.dataSource.data[this.dataSource.data.length - 1][value]
          }

          let objex = this.displayedColumns.find(va => va.name === value);
          let labelValue = objex !== undefined ? objex.label : value;
          const valuearray: string[] = this.dataSource.data[index][value].split(',');


          if (lastvalue !== '' && !labelValue.includes("Excluded") &&
            //lastvalue !== this.dataSource.data[index][value])
          (valuearray[0] && !valuearray[0].includes(lastvalue))) {
            if (this.dataSource.data[index][value] !== "All" && !this.dataSource.data[index][value].includes("-1") && !this.dataSource.data[index][value].includes("*")) {
              return " mismatch text-danger _600";
            }
          }
          else {
            if (lastvalue !== '' &&  lastvalue !== '-1'&&  lastvalue !== '*') {
              if (labelValue.includes("Excluded") &&
                //lastvalue == this.dataSource.data[index][value]
                (valuearray[index] !== undefined && valuearray[index].includes(lastvalue))
                || this.dataSource.data[index][value] === "All") {
                return " mismatch text-danger _600";
              }
            }
          }
        }

        break;
    }
  }
  getRules() {
    if (this.selectedHandler !== undefined) {
      let obj = {
        DeploymentKey: this.requisitionNumber.DeploymentKey,
        CaseId: this.requisitionNumber.caseid,
        RuleIds: this.selectedHandler.RuleInfo !== undefined ? this.selectedHandler.RuleInfo.map((a) => a.RuleId) : [],
      };
      this.dataSource.data = [];
      this.ngxUiLoaderService.start();
      this.service.getInterfaceDetailsRule(obj).subscribe((data) => {
        this.ngxUiLoaderService.stop();

        if (data.status == "success") {
          this.ngxUiLoaderService.stop();

          this.casesruleinfo = JSON.parse(data.responsebody).casesruleinfo;
          if (this.casesruleinfo.length > 0) {
            this.casesruleinfo.forEach((va) => {
              va['ExOrdFacilityId'] = va.OFAccountName,
                va['ExServices'] = va.Service,
                va['ExCaseTypes'] = va.CaseType
              va["Indentifier"] = "Case"
            });
          }
          this.varuleinfo = JSON.parse(data.responsebody).varuleinfo;
          if (this.varuleinfo.length > 0) {
            this.varuleinfo.forEach((va, index) => {
              const ruleId = this.selectedHandler?.RuleInfo?.[index]?.RuleId;
              va["Indentifier"] = ruleId ? `Rule(${ruleId})` : "Rule";
              (va["LabAccountName"] = va["LabId"]),
                (va["LabOrgName"] = va["LabOrgName"]),
                (va["OFAccountName"] = va["OrdFacilityId"]),
                (va["OrdFacOrgName"] = va["OrdFacOrgName"]),
                (va["PhysicianUserName"] = va["OFUserId"]),
                (va["PathologistUserName"] = va["PathologistId"]),
                (va["PathOrgName"] = va["PathOrgId"]),
                (va["PathAccountName"] = va["PathAccountId"]);
            });
          }
          let ruleData = this.varuleinfo.concat(this.casesruleinfo);
          ruleData.map((va) => {
            (va.ExOrdFacilityId = va.ExOrdFacilityId == va.OrdFacilityId ? va.OFAccountName : va.ExOrdFacilityId),
              (va.ExServices = va.ExServices === va.Service ? va.Service : va.ExServices),
              (va.ExCaseTypes = va.ExCaseTypes === va.CaseType ? va.CaseType : va.ExCaseTypes);
            // (va.ExOrdFacilityId = va.OFAccountName),
            //   (va.ExServices = va.Service),
            //   (va.ExCaseTypes = va.CaseType);
          });

          this.Alldata = ruleData;
          this.displayedColumns = this.AllColumns;
          this.dataSource = new MatTableDataSource(ruleData);
          this.getunmatch(ruleData);
        }
      }, error => {
        this.ngxUiLoaderService.stop();

      });
    }
  }

  getunmatch(Casedata) {

    this.differenceColumns = [];
    for (let i = 0; i < this.AllColumns.length; i++) {
      let colName = this.AllColumns[i].name;
      for (let j = 0; j < Casedata.length; j++) {
        if (Casedata.length - 1 !== j) {
          let lastvalue = ''

          if (Casedata[Casedata.length - 1][colName] !== undefined &&
            Casedata[Casedata.length - 1][colName].includes("(")) {
            let splitedData = Casedata[Casedata.length - 1][colName].split("(")
            if (splitedData.length) {
              lastvalue = splitedData[1].split(")")[0]
            }
          }
          else {
            lastvalue = Casedata[Casedata.length - 1][colName]
          }
          if (Casedata[j][colName] !== undefined) {
            //console.log(Casedata[j][colName])
            const valuearray: string[] = (Casedata[j][colName] !== '' && Casedata[j][colName] !== undefined) ? Casedata[j][colName].split(',') : '';

            if (!this.AllColumns[i].label.includes("Excluded") &&
              Casedata[j][colName] !== "All" && !Casedata[j][colName].includes("-1") && !Casedata[j][colName].includes("*")&&
              // lastvalue !== Casedata[j][colName]
             (valuearray[0] !==undefined && !valuearray[0].includes(lastvalue))
            ) {
              let exist = [];
              if (this.differenceColumns.length > 0) {
                exist = this.differenceColumns.filter(
                  (va) => va.name === this.AllColumns[i].name
                );
              }
              if (exist.length == 0) {
                this.differenceColumns.push(this.AllColumns[i]);
              }
            }
            else {
              if ((this.AllColumns[i].label.includes("Excluded") &&
                lastvalue == Casedata[j][colName]
                // valuearray.includes(lastvalue)
                && Casedata[j][colName] !== '') ||
                (this.AllColumns[i].label.includes("Excluded") && Casedata[j][colName] === "All")) {
                let exist = [];
                if (this.differenceColumns.length > 0) {
                  exist = this.differenceColumns.filter(
                    (va) => va.name === this.AllColumns[i].name
                  );
                }
                if (exist.length == 0) {
                  this.differenceColumns.push(this.AllColumns[i]);
                }
              }
            }
          }
        }
      }
    }
    ;
    if (this.differenceColumns.length > 0) {
      this.displayedColumnstab = this.differenceColumns.map((def) => def.name);
    }
  }

  CheckValidationStauts(item) {
    if (item.status == '11' || item.status == '13') {
      if(item.DeliveredStageOutputData.includes("Ignored") || item.DeliveredStageOutputData.includes("Fail")){
        return false;
      }
      else{
        return true;
      }
    }
    else {
      return false;
    }
  }

  OnValidation(uniq) {

    let DataValidationInputs: any = []
    let obj = {
      CaseId: this.requisitionNumber.caseid.toString(),
      MessageID: uniq.messageid,
      Deployment: this.requisitionNumber.DeploymentKey,
      Direction: this.requisitionNumber.Direction,
      MessageType: uniq.messagetype
   
    }
    DataValidationInputs.push(obj);
    //console.log(DataValidationInputs);
    this.ngxUiLoaderService.start();
    this.service.dataValidationapi(DataValidationInputs).subscribe((data: any) => {
     //console.log("output data from data validation api is :: " + JSON.stringify(data))
      this.ngxUiLoaderService.stop();
      const modalRef = this.modalService.open(DataValidationComponent, {
        windowClass: "Mode_Bootcase360",
        backdrop: "static",
        keyboard: false,
      });
      modalRef.componentInstance.inputDataInModalComponent = data
      this.currentModalRefs.push(modalRef);
      
      modalRef.result.then((result) => {
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
      }, (reason) => {
        this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
      });
      
      // Add data attribute to identify the modal and backdrop
      this.modalTabVisibility.tagOwned('data-case360-modal', 'Mode_Bootcase360');
      
      this.modalWasOpen = true;
    },
      (error) => {
     //   console.log("Error occured while calling data validation api. error is :: " + error)
        this.toastr.warning("Error occured while calling data validation api", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
        this.ngxUiLoaderService.stop();
      }
    );
  }

  openMessage(modalrefid, uniq) {
    let obj = {
      MessageUniqueIds: uniq.id,
    };
    this.selectedMessage = uniq;
    this.ngxUiLoaderService.start();
    this.service.getInterfaceDetailsMessages360Stage(obj).subscribe(
      (data) => {
        this.ngxUiLoaderService.stop();
        if (data.length > 0) {
          data = data.filter((va) => va.stagename.toLowerCase() !== "accepted");
          this.iconsList = data.sort((a, b) => a.stage - b.stage);
          const modalRef = this.modalService
            .open(modalrefid, {
              windowClass: "viewstagescasemsg360",
              backdrop: "static",
              keyboard: false,
            });
          this.currentModalRefs.push(modalRef);
          
          modalRef.result.then((result) => {
            this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
          }, (reason) => {
            this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
          });
          
          // Add data attribute to identify the modal and backdrop
          this.modalTabVisibility.tagOwned('data-case360-modal', 'viewstagescasemsg360');
          
          this.modalWasOpen = true;
          this.iconsList.map((icon, index) => {
            icon["isActive"] = index === 0 ? true : false;
          });
          this.transformedStage(0);
        } else {
          this.toastr.warning("Stage data not found", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        }
      },
      (error) => {
        this.ngxUiLoaderService.stop();
      }
    );
  }
  downloadfile(fileId, iscontainsmultiplefileid) {
    if (iscontainsmultiplefileid && this.fileidarray.length > 0) {
      for (var i = 0; i < this.fileidarray.length; i++) {
        this.downloadcontents(
          this.fileidarray[i].fileid,
          this.fileidarray[i].filename,
          "download",
          ""
        );
      }
    } else {
      this.downloadcontents(fileId, "", "download", "");
    }
  }
  openstagedata(item: any) { }
  transformedStage(index: number) {
    this.iconsList.map((va) => (va.isActive = false));
    this.iconsList[index].isActive = true;
    if (this.iconsList[index] != "") {
      this.selectedStageData = this.iconsList[index];
      this.selectedInput = this.iconsList[index].stageinput;
      this.selectedOutput = this.iconsList[index].outputdata;
    } else {
      this.selectedInput = "";
      this.selectedOutput = "";
    }
  }
  copyToClip(event: any, message: string) {
    if (event != "") {
      copyToClipboard(event);
      this.toastr.success(message, "", {
        timeOut: 500,
        positionClass: "toast-bottom-right",
      });
    }
  }
  
  GetTraceData(mymodalstagelogs, messageid) {
    this.displaymessageid = messageid;
    this.ngxUiLoaderService.start();
    var url =
      "api/HubMessage/GetTraceData?messageid=" +
      messageid;
    this.service.getapiurl(url).subscribe({
      next: data => {
        if (data.length > 0) {
          this.MessageTraceData = data as any;
          this.displaymessageid = messageid;
          if (mymodalstagelogs != "") {
            const modalRef = this.modalService
              .open(mymodalstagelogs, {
                windowClass: "myCustomModalClasscase360",
                backdrop: "static",
                keyboard: false,
              });
            this.currentModalRefs.push(modalRef);
            
            modalRef.result.then(result => {
              this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
            }, (reason) => {
              this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
            });
            
            // Add data attribute to identify the modal and backdrop
            this.modalTabVisibility.tagOwned('data-case360-modal', 'myCustomModalClasscase360');
            
            this.modalWasOpen = true;
          } else {
            this.downloadFile(
              this.MessageTraceData,
              this.MessageTraceData[0]["traceid"]
            );
          }
        } else {
          this.toastr.warning(
            "There is no logs in this Message ID :" +
            " " +
            this.displaymessageid,
            "",
            {
              timeOut: 4000,
              positionClass: "toast-bottom-right",
            }
          );
        }
        this.ngxUiLoaderService.stop();
      },
      error: error => {
        this.ngxUiLoaderService.stop();
        this.toastr.error("Failure to download logs", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      },
    });
  }

  copyToClips(event: any, message: string) {
    if (event !== '') {
      copyToClipboard(event);
    }
    this.toastr.success(message + " " + "Copied", "", {
      timeOut:500,
      positionClass: "toast-bottom-right",
    });
  }
  closestagepopup(c) {
    c("close modal");
  }
  searchFilter(event) {
    if (event.target.value !== undefined) {
      this.searchTextValue = event.target.value;
      this.selectedHandler = "";
      this.MessagesList = [];
      if (this.selectedTabIndex == 0) {
        this.InEventList.map((va) => (va.isactive = false));
        this.InEventList[0].isactive = true;
        this.IneventLogListBackup.map((va) => (va.isActive = false));
        this.IneventLogList = this.IneventLogListBackup.filter((va) =>
          va.RouteName.toLowerCase().includes(
            this.searchTextValue.toLowerCase()
          )
        );
        this.AfterChangeInlogsbackup = JSON.parse(
          JSON.stringify(this.IneventLogList)
        );
      } else {
        this.EventList.map((va) => (va.isactive = false));
        this.EventList[0].isactive = true;
        this.eventLogListBackup.map((va) => (va.isActive = false));
        this.eventLogList = this.eventLogListBackup.filter((va) =>
          va.RouteName.toLowerCase().includes(
            this.searchTextValue.toLowerCase()
          )
        );
        this.AfterChangelogsbackup = JSON.parse(
          JSON.stringify(this.eventLogList)
        );
      }
    }
  }
  downloadFile(data, filename = "data") {
    let csvData = this.ConvertToCSV(data, [
      "agentid",
      "messageid",
      "method",
      "routedefinitionid",
      "messagetype",
      "senderagentid",
      "sourceentityid",
      "destinationentityid",
      "destinationagentid",
      "response",
      "createddate",
      "fileid",
      "invokedurl",
      "stage",
      "hash",
      "response",
      "processingparam",
      "status",
      "processingtime",
    ]);
    let blob = new Blob(["\ufeff" + csvData], {
      type: "text/csv;charset=utf-8;",
    });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  ConvertToCSV(objArray, headerList) {
    let items = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let separator = ",";
    const columns = Object.keys(items[0]).join(separator);
    const body = items
      .map((item) => Object.values(item).join(separator))
      .join("\n");
    return columns + "\n" + body;
  }
  getmessage_iot(value, modalmessageiot) {
    this.ngxUiLoaderService.start();
    this.msgObjforiot = value;
    this.service
      .Hubmessage_IOTData(this.msgObjforiot["id"], this.msgObjforiot["messagepayloadreference"],false)
      .subscribe(
        (data) => {
          if (data) {
            this.message_iot_data = data;
            this.message_iot_data["title"] = this.msgObjforiot["messageid"];
            if (this.message_iot_data["InputData"]) {
              if (
                this.service.IsJsonString(this.message_iot_data["InputData"])
              ) {
                this.message_iot_data["InputData"] = JSON.stringify(
                  JSON.parse(this.message_iot_data["InputData"]),
                  null,
                  2
                );
              } else if (this.IsValidXML(this.message_iot_data["InputData"])) {
                this.message_iot_data["InputData"] = beautify(
                  this.message_iot_data["InputData"]
                );
              }
              this.editorInit(this.message_iot_data["InputData"], '', 'input');
            }
            if (this.message_iot_data["TransformedData"]) {
              if (
                this.service.IsJsonString(
                  this.message_iot_data["TransformedData"]
                )
              ) {
                let transformparse = JSON.parse(this.message_iot_data["TransformedData"]);
                this.fileidarray = transformparse;
                this.message_iot_data["TransformedData"] = JSON.stringify(
                  JSON.parse(this.message_iot_data["TransformedData"]),
                  null,
                  2
                );
              } else if (
                this.IsValidXML(this.message_iot_data["TransformedData"])
              ) {
                this.message_iot_data["TransformedData"] = beautify(
                  this.message_iot_data["TransformedData"]
                );
              }
              this.editorInit(this.message_iot_data["TransformedData"], '', 'TransformedData');
            }
            if (this.service.IsJsonString(this.message_iot_data["TransformedData"]) && this.message_iot_data["TransformedData"] !== null) {
              this.downloadbuttonenable = true;
            }
            else {
              this.downloadbuttonenable = false;
            }
            this.ngxUiLoaderService.stop();
            const modalRef = this.modalService
              .open(modalmessageiot, {
                windowClass: "messageiotcase360",
                backdrop: "static",
                keyboard: false,
              });
            this.currentModalRefs.push(modalRef);
            
            modalRef.result.then((result) => {
              this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
            }, (reason) => {
              this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
            });
            
            // Add data attribute to identify the modal and backdrop
            this.modalTabVisibility.tagOwned('data-case360-modal', 'messageiotcase360');
            
            this.modalWasOpen = true;
              this.service.auditsave("View","",
                "Consolidated view for messageid :-"+value?.messageid,"case",this.requisitionNumber['caseguid'], "Case message tab ,deployment key :-"+this.requisitionNumber.DeploymentKey );
          }
        },
        (error) => {
          this.ngxUiLoaderService.stop();
          this.service.copyableToastError(error.statusText);
        }
      );
  }
  editorOptions1 = {
    theme: 'vs', language: this.formatType,readOnly:true, wordWrap: 'on',scrollBeyondLastLine: false
};
  editorInit(data, editor: any, type) {
    let formatType;
      if (this.IsValidXML(data)) {
        formatType = "xml";
      } else if (this.service.IsJsonString(data)) {
        formatType = "json";
      } else {
        formatType = "hl7";
      }
      if(this.defaultFormatType!=this.formatType){
        this.defaultFormatType=this.formatType;
      if (type == "input") {
        this.editorOptions1 = { ...this.editorOptions1, language: formatType };
      } else {
        this.editorOptions = { ...this.editorOptions, language: formatType };
      }
    }
  }
  editmessageiot(data) {
    this.messageiotreprocess = true;
    this.backupinputdata = data;
    this.editorOptions1.readOnly = false;
  }
  resetmessageiot() {
    this.messageiotreprocess = false;
    this.message_iot_data["InputData"] = this.backupinputdata;
    this.editorOptions1.readOnly = true;
  }
  IsValidXML(data) {
    let xmlDocument: any;
    let isValid = false;
    try {
      xmlDocument = new DOMParser().parseFromString(data, "text/xml");
      isValid = true;
    } catch {
      xmlDocument = "";
      isValid = false;
    }
    return isValid;
  }
  async reprocessSelected(value) {
    // if (value.selected.length > 0) {
    //   this.checkeddata = value.selected;
    this.messagereprocessdata = [];
    // this.checkeddata.forEach(element => {
    var dataCons = {
      id: value.id,
      transactionid: value.transactionid,
      sourceagentapikey: value.sourceagentapikey,
      sourceagentid: value.sourceagentid,
      sourceentityid: value.sourceentityid,
      destinationentityid: value.destinationentityid,
      messagetype: value.messagetype,
      mode: value.mode,
      messageid: value.messageid,
      parentmessageid: value.parentmessageid,
      parentmessagereferenceid:value.parentmessagereferenceid,
      format: value.format,
      fileid: value.messagepayloadreference,
      routedefinitionid: value.routedefinitionid,
      verifyroute: "true",
      modifiedby: JSON.parse(sessionStorage.getItem("sessionObjectlogin"))
        .userdata["userid"],
      parentfileid: value.parentfileid,
      parentfilename: value.parentfilename,
      filename :value.filename,
      objectid: value.objectid,
      objecttype: value.objecttype
    };
    this.messagereprocessdata.push(dataCons);
    // });
    
    const message = `Are you sure you want to reprocess this message?`;
    const dialogData = new ConfirmDialogModel("Confirm Action", message, 'confirm', '');
    // Original open() included: scrollStrategy: this.overlay.scrollStrategies.noop() — left commented; shell scroll handled globally.
    const dialogRef = this.dialog.open(ConfirmDialogComponent, 
      { maxWidth: "500px", data: dialogData, disableClose: true 
      , panelClass: 'confirm-dialog-panel',
      // scrollStrategy: this.overlay.scrollStrategies.noop()
    });
    const dialogResult = await dialogRef.afterClosed().toPromise();
    if (dialogResult === false) {
      return;
    }
    this.ngxUiLoaderService.start();
    var apiname = "api/HubMessage/BatchMessageReprocess";
    this.service.searchpostapi(apiname, this.messagereprocessdata).then(
      (response) => {
        if (response["status"] && response["statusText"]) {
          this.ngxUiLoaderService.stop();
          this.toastr.error("Reprocess failed", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
          
          this.service.auditsave("View","",
            "Reprocess failed: " +this.messagereprocessdata[0].messageid,
            "case",this.requisitionNumber['caseguid'], "Case message tab ,deployment key :-"+this.requisitionNumber.DeploymentKey );
        } else {
          this.ngxUiLoaderService.stop();
          if (response["status"] == "failure") {
            this.service.copyableToastError(response["statusmessage"]);
            this.service.auditsave("View","",
              response["statusmessage"] +this.messagereprocessdata[0].messageid,
              "case",this.requisitionNumber['caseguid'], "Case message tab ,deployment key :-"+this.requisitionNumber.DeploymentKey );
          } else {
            if (this.selectedDirection == "in") {
              this.InBoundList();
              // let ins = this.IneventLogList.findIndex(
              //   (va) => va.RouteName == this.selectedHandler.RouteName
              // );
              // if (ins != -1) {
              //   this.selectedEventCard(ins, this.selectedDirection);
              // } else {
              //   this.selectedEventCard(0, this.selectedDirection);
              // }
            } else {
              this.OutBoundList();
              // let ins = this.eventLogList.findIndex(
              //   (va) => va.RouteName == this.selectedHandler.RouteName
              // );
              // if (ins != -1) {
              //   this.selectedEventCard(ins, this.selectedDirection);
              // } else {
              //   this.selectedEventCard(0, this.selectedDirection);
              // }
            }

            this.service.showAsyncStatusUpdateToast('reprocess');
            this.service.auditsave("View","",
              "Reprocessed successfully Message ID: " +this.messagereprocessdata[0].messageid,
              "case",this.requisitionNumber['caseguid'], "Case message tab ,deployment key :-"+this.requisitionNumber.DeploymentKey );
          }
        }
      },
      (error) => {
        this.ngxUiLoaderService.stop();
        this.toastr.error("Something Went Wrong!", "", {
          timeOut: 4000,
          positionClass: "toast-bottom-right",
        });
      }
    );
    // this.selection.clear();
    // this.SearchMessages();
    // }
  }
  onTabChanged(value) {
    this.selectedHandler = "";
    if (value.index !== undefined) {
      this.selectedTabIndex = value.index;
    } else {
      this.selectedTabIndex = value;
    }
    if (this.selectedTabIndex == 0) {
      this.InBoundList();
    } else {
      this.OutBoundList();
    }
  }

  /* download changes start*/
  downloadfilebyFileid(isflag, modalpopup) {
    this.ngxUiLoaderService.start();
    if (this.fileidarray.length > 0) {
      this.backupfileArray = []
      for (var i = 0; i < this.fileidarray.length; i++) {
        this.downloadcontents(this.fileidarray[i].fileid, this.fileidarray[i].filename, isflag, modalpopup)
      }
    }
    else {
      //this.downloadcontents(fileId);
    }
    //this.ngxUiLoaderService.stop();
  }

  downloadcontents(fileids, filename, isflag, modalpopup) {
    let jsondata = {
      messagetype: this.selectedHandler.MessageType,
      fileid: fileids,
      contextId: this.selectedHandler.RouteUniqueId,
      createdBy: JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
    };
    this.ngxUiLoaderService.start();
    this.service.GetFileContentByFileID(jsondata).subscribe((response: any) => {
      this.ngxUiLoaderService.stop();
      if (response.length > 0) {
        this.backupfileArray = response.concat(this.backupfileArray)
      } else {
        this.backupfileArray.push({})
      }
      this.ngxUiLoaderService.start();
      if (this.fileidarray.length == 1 && response.length == 1 && isflag == "view") {
        response[0].filename=filename;
        this.viewFile(response[0])
        this.ngxUiLoaderService.stop();
      } else if (this.fileidarray.length === this.backupfileArray.length && isflag == "view") {
        this.fileidarray.forEach(element => {
          let uniq = this.backupfileArray.find(va => va.fileid == element.fileid)
            uniq.filename = element.filename
            this.ngxUiLoaderService.stop();
        });
        const modalRef = this.modalService.open(ConsolidateviewfileComponent, { windowClass: "PopupScreencase360", backdrop: "static", keyboard: false });
        modalRef.componentInstance.backupfileArray = this.backupfileArray;
        this.currentModalRefs.push(modalRef);
        
        modalRef.result.then(() => {
          this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
        }, (reason) => {
          this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
        });
        
        // Add data attribute to identify the modal and backdrop
        this.modalTabVisibility.tagOwned('data-case360-modal', 'PopupScreencase360');
        
        this.modalWasOpen = true;
      } else if (isflag == "download") {
        response.forEach(element => {
          if (element.filecontent != null) {
            filename = filename == '' ? element.filename : filename;
            if (filename == '') {
              filename = element.fileid + element.fileformat;
            }
            this.ngxUiLoaderService.stop();
            this.downloadFiles(element, filename);
          }
          else {
            this.ngxUiLoaderService.stop();
          }
        });
      }
      this.ngxUiLoaderService.stop();
    });
  }
  selectFile(response) {
    this.viewFile(response)
  }
  downloadFiles(data: any, filename: any) {
    if (!filename.includes(".")) {
      filename = filename + "." + data.fileformat;
    }
    var decodedContent = null;
    if (data.fileformat == "pdf") {
      this.ngxUiLoaderService.start();
      decodedContent = 'data:application/pdf;base64,' + data.filecontent;
      const link = document.createElement('a');
      link.href = decodedContent;
      link.download = filename;
      link.click();
      this.ngxUiLoaderService.stop();
    }
    else if (data.fileformat !== null) {
      this.ngxUiLoaderService.start();
      decodedContent = data.filecontent;
      let contype = 'application/octet-stream';
      const file = new window.Blob([decodedContent], { type: contype });
      const downloadAncher = document.createElement("a");
      const fileURL = URL.createObjectURL(file);
      downloadAncher.href = fileURL;
      downloadAncher.download = filename;
      downloadAncher.click();
      this.ngxUiLoaderService.stop();
    }
  }
  /* download changes end*/

  //view the downloand file 
  viewFile(response) {
    this.ngxUiLoaderService.start();
    let namemodal = {
      name: response.filename,
      fullfile: response.filecontent,
      type: response.fileformat
    }
    const modalRef = this.modalService.open(FileViewExplorerComponent
      , {
        windowClass: "myCustomModalViewfilecase360",
        backdrop: "static",
        keyboard: false
      });
    modalRef.componentInstance.fileData = namemodal;
    modalRef.componentInstance.fileType = response.fileformat;
    this.ngxUiLoaderService.stop();
    this.currentModalRefs.push(modalRef);
    
    modalRef.result.then(() => {
      this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
    }, (reason) => {
      this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
    });
    
    // Add data attribute to identify the modal and backdrop
    this.modalTabVisibility.tagOwned('data-case360-modal', 'myCustomModalViewfilecase360');
    
    this.modalWasOpen = true;
  }


  getRuleIds(item: any): string {
    if (!item?.RuleInfo?.length) {
      return '';
    }
    return item.RuleInfo
      .map((r: any) => r.RuleId)
      .filter((id: any) => id)
      .join(', ');
  }

  borderClass(value) {
    switch (value) {
      case 11:
        return "active_card_bor messageInfo box m-0";
      case 12:
        return "failed_card_bor messageInfo box m-0";
      case 10:
        return "created_card_bor messageInfo box m-0";
      case 14:
        return "ignore_card_bor messageInfo box m-0";
      case 25:
        return "inprogress_card_bor messageInfo box m-0";
      case 9:
        return "hold_card_bor messageInfo box m-0";
      default:
        return " messageInfo box m-0";
    }
  }
  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
    }
    
    this.destroy$.next();
    this.destroy$.complete();
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
    if (this.folderviewSubscribe) {
      this.folderviewSubscribe.unsubscribe();
    }
  }
  
  ngOnDestory() {
    this.ngOnDestroy();
  }

  /**
   * Case 360 Messages: hub app uses header timezone; SSO/embedded launch shows API value as-is.
   */
  formatCaseMessageDate(
    datetime: string | null | undefined,
    displayFormat = 'M/d/yyyy h:mm:ss a'
  ): string {
    if (!datetime) {
      return '';
    }
    if (!this.service.isHubApplication()) {
      return datetime;
    }
    return this.service.formatDateTimeForDisplay(
      datetime,
      displayFormat,
      this.service.logsApiTimezone
    );
  }

  redirectinterface(route){
    this.service.setcaseintObj(JSON.stringify(route));
  }
  
  hideModals() {
  const result = this.modalTabVisibility.hideOwned('data-case360-modal', {
    hasOpenRefs: this.currentModalRefs?.length > 0,
    windowClasses: ["myCustomModalClasscase360audit","myCustomModalViewfilecase360","myCustomModalClasscase360hl7","myCustomModalClassFTPcase360","myCustomModalClasscase360","Mode_Bootcase360","viewstagescasemsg360","viewstagescase360","messageiotcase360","PopupScreencase360"],
    nestedOwnerAttrs: ['data-case360-nested-modal'],
  });
  this.modalWasOpen = result.modalWasOpen;
}

showModals() {
  this.modalTabVisibility.showOwned('data-case360-modal', {
    modalWasOpen: this.modalWasOpen,
    hasOpenRefs: this.currentModalRefs?.length > 0,
    windowClasses: ["myCustomModalClasscase360audit","myCustomModalViewfilecase360","myCustomModalClasscase360hl7","myCustomModalClassFTPcase360","myCustomModalClasscase360","Mode_Bootcase360","viewstagescasemsg360","viewstagescase360","messageiotcase360","PopupScreencase360"],
    nestedOwnerAttrs: ['data-case360-nested-modal'],
  });
}
}

// TODO: This data stuff should be a service
export interface TableData {
  col1: string;
  col2: string;
  col3: string;
  col4: string;
  col5: string;
  col6: string;
  col7: string;
  col8: string;
  col9: string;
  col10: string;
  col11: string;
  col12: string;
  col13: string;
  col14: string;
  col15: string;
  col16: string;
  col17: string;
  col18: string;
}

const TABLE_DATA: TableData[] = [
  {
    col1: "val",
    col2: "val",
    col3: "val",
    col4: "val",
    col5: "val",
    col6: "val",
    col7: "val",
    col8: "val",
    col9: "val",
    col10: "val",
    col11: "val",
    col12: "val",
    col13: "val",
    col14: "val",
    col15: "val",
    col16: "val",
    col17: "val",
    col18: "val",
  },
];
